import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const CurrentStudyContext = createContext({
  current: null,
  loading: true,
  refresh: () => {},
  setCurrent: () => {},
  clearCurrent: () => {},
});

export function CurrentStudyProvider({ children }) {
  const [current, setCurrentState] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/user/current-study");
      setCurrentState(r.data?.id ? r.data : null);
    } catch {
      setCurrentState(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const setCurrent = useCallback(async (dispId) => {
    if (!dispId) return;
    try {
      await api.put("/user/current-study", { disp_id: dispId });
      await refresh();
    } catch {
      // silent
    }
  }, [refresh]);

  const clearCurrent = useCallback(async () => {
    try {
      await api.put("/user/current-study", { disp_id: "" });
      await refresh();
    } catch {
      // silent
    }
  }, [refresh]);

  return (
    <CurrentStudyContext.Provider value={{ current, loading, refresh, setCurrent, clearCurrent }}>
      {children}
    </CurrentStudyContext.Provider>
  );
}

export const useCurrentStudy = () => useContext(CurrentStudyContext);
